import type { ComponentProps, FC } from "react"

import type { OperationKind } from "@productlane/lib/src/api-reference"
import { apiMethodLabel } from "@productlane/lib/src/api-reference/method-label"
import { cn } from "@productlane/lib/src/cn"

import { Badge } from "../badge"

// Its own file so a nav list can show methods without pulling in the reference view.
const METHOD_BADGE: Record<string, ComponentProps<typeof Badge>["variant"]> = {
	GET: "blue",
	POST: "green",
	PUT: "amber",
	PATCH: "amber",
	DEL: "red",
}

export const ApiMethodBadge: FC<{
	method: string
	kind: OperationKind
	className?: string
}> = ({ method, kind, className }) => {
	const label = apiMethodLabel(method, kind)
	return (
		<Badge
			variant={METHOD_BADGE[label] ?? "light-gray"}
			size="code"
			className={cn("font-semibold", className)}
		>
			{label}
		</Badge>
	)
}
